import { createContext, useContext, useState, ReactNode } from 'react';

type DebugContextType = {
  showDebugToolbar: boolean;
  setShowDebugToolbar: (show: boolean) => void;
  darkMode: boolean;
  toggleDarkMode: () => void;
};

const DebugContext = createContext<DebugContextType | undefined>(undefined);

type DebugProviderProps = {
  children: ReactNode;
  darkMode: boolean;
  setDarkMode: (dark: boolean) => void;
};

export const DebugProvider = ({
  children,
  darkMode,
  setDarkMode,
}: DebugProviderProps) => {
  const [showDebugToolbar, setShowDebugToolbar] = useState(() => {
    const saved = localStorage.getItem('showDebugToolbar');
    return saved === 'true';
  });

  const handleSetShowDebugToolbar = (show: boolean) => {
    setShowDebugToolbar(show);
    localStorage.setItem('showDebugToolbar', String(show));
  };

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  return (
    <DebugContext.Provider
      value={{
        showDebugToolbar,
        setShowDebugToolbar: handleSetShowDebugToolbar,
        darkMode,
        toggleDarkMode,
      }}
    >
      {children}
    </DebugContext.Provider>
  );
};

export const useDebug = () => {
  const context = useContext(DebugContext);
  if (context === undefined) {
    throw new Error('useDebug must be used within a DebugProvider');
  }
  return context;
};
